import styled from 'styled-components';

export const DropzoneWrapper = styled.div`
  margin: 12px;
`;
